import { IChipOption } from 'components/ChipSelect';
import { KbsEntityLookupWrapper } from 'components/Lookups/KbsEntityLookups/KbsEntityLookupWrapper';
import React from 'react';
import { LookupChipSelect } from '../LookupChipSelect';

interface IProps {
  includeDeleted?: boolean;
  selectedIds?: number[];
  onChange: (selectedOptions: readonly IChipOption[]) => void;
  placeholder?: string;
}

export const KbsEntityChipSelect = (props: IProps): JSX.Element => {
  return (
    <KbsEntityLookupWrapper includeDeleted={props.includeDeleted}>
      {({ queryDocument, queryVariables, extractLookups }) => (
        <LookupChipSelect
          extractLookups={extractLookups}
          queryDocument={queryDocument}
          queryVariables={queryVariables}
          onChange={props.onChange}
          selectedIds={props.selectedIds}
          placeholder={props.placeholder}
        />
      )}
    </KbsEntityLookupWrapper>
  );
};
